import { Box } from '@mui/material'
import React from 'react'
import { useScreenSize } from '../../hooks/useScreenSize'
import { Countdown } from './Countdown'

// Button should be wrapped in <Box sx={{ position: 'relative' }}></Box>

export const ButtonCountdown: React.FC<{ resetDate: string; callback: () => void }> = ({ resetDate, callback }) => {
    const { isMobile } = useScreenSize()
    return (
        <Box
            sx={{
                position: 'absolute',
                '&:not(:has(> p))': {
                    display: 'none',
                },
                ':has(> p)': {
                    display: 'block',
                },
                bottom: isMobile ? '-25%' : '-17%',
                right: '50%',
                transform: 'translateX(50%)',
                minWidth: '48px',
                backgroundColor: 'secondary.main',

                outline: (theme) => `2px solid ${theme.palette.background.default}`,
                '> p': {
                    textAlign: 'center',
                    fontSize: '11px',
                    color: 'background.default',
                    lineHeight: '12px',
                    whiteSpace: 'nowrap',
                },
            }}
        >
            <Countdown resetDate={resetDate} loader={false} callback={callback} />
        </Box>
    )
}
